import {useQuery} from "@tanstack/react-query";
import {getExpedientQueryOptions} from "./get-expedient.query-options";

export function useGetExpedient(id: string) {
  return useQuery(getExpedientQueryOptions(id));
}
